<template>
  <div class="product-recommendation product-recommendation-more-items">
    <!-- <template v-if="hasNicheWeedProductTag">
      <template
        v-if="loading || productStore.productRecommendation?.fatherWeed?.length"
      >
        <div class="pt-xs"></div>
        <h2 class="text--center">Best Gifts For Chill Dads</h2>
        <ProductListSlider
          :products="
            productStore.productRecommendation?.fatherWeed?.length
              ? productStore.productRecommendation.fatherWeed
              : placeholderProducts
          "
          @item-click="trackingProductRecommendationClicked"
        />
      </template>

      <template
        v-if="loading || productStore.productRecommendation?.motherWeed?.length"
      >
        <div class="pt-xs"></div>
        <h2 class="text--center">Perfect Gifts For Chill Mothers</h2>
        <ProductListSlider
          :products="
            productStore.productRecommendation?.motherWeed?.length
              ? productStore.productRecommendation.motherWeed
              : placeholderProducts
          "
          @item-click="trackingProductRecommendationClicked"
        />
      </template>

      <template
        v-if="loading || productStore.productRecommendation?.coupleWeed?.length"
      >
        <div class="pt-xs"></div>
        <h2 class="text--center">Special Gifts For Chill Couples</h2>
        <ProductListSlider
          :products="
            productStore.productRecommendation?.coupleWeed?.length
              ? productStore.productRecommendation.coupleWeed
              : placeholderProducts
          "
          @item-click="trackingProductRecommendationClicked"
        />
      </template>
    </template> -->

    <template
      v-if="loading || productStore.productRecommendation?.nicheItems?.length"
    >
      <h2 class="text--center">
        {{ productSeeMoreCollections?.similarNicheCollection?.title }}
      </h2>
      <ProductListSlider
        :products="
          productStore.productRecommendation?.nicheItems?.length
            ? productStore.productRecommendation.nicheItems
            : placeholderProducts
        "
        @item-click="trackingProductRecommendationClicked"
        :referer="PRODUCT_PAGE_NICHE_ITEMS"
        class="mb-lg"
      />
    </template>

    <div
      class="product-recommend-button-group text--center"
      v-if="
        productSeeMoreCollections?.similarNicheCollection &&
        productStore.productRecommendation?.nicheItems?.length
      "
    >
      <sib-link
        :to="
          buildCollectionUrl(
            productSeeMoreCollections.similarNicheCollection.handle
          )
        "
        :key="productSeeMoreCollections.similarNicheCollection.handle"
        :title="productSeeMoreCollections.similarNicheCollection.title || ''"
        class="sib-button sib-button--primary"
        :class="{
          'sib-button--width-auto': !deviceStore.isMobile,
        }"
        @click="trackingClickButtonNicheCollection"
        :referer="PRODUCT_PAGE_EXPLORE_BUTTON"
      >
        {{ productSeeMoreCollections.similarNicheCollection.title }}
      </sib-link>
    </div>
    <template
      v-if="
        variantMassProductABTest &&
        (loading || productStore.productRecommendation?.moreItems?.length)
      "
    >
      <h2 class="text--center">More Items To Consider</h2>
      <ProductListSlider
        class="product-mass"
        :products="
          productStore.productRecommendation?.productMass?.length
            ? productStore.productRecommendation.productMass
            : placeholderProducts
        "
        @item-click="trackingProductRecommendationClicked"
        :referer="PRODUCT_PAGE_MORE_ITEMS"
      />
    </template>
    <template
      v-else-if="
        loading || productStore.productRecommendation?.moreItems?.length
      "
    >
      <h2 class="text--center">More Items To Consider</h2>
      <ProductListSlider
        :products="
          productStore.productRecommendation?.moreItems?.length
            ? productStore.productRecommendation.moreItems
            : placeholderProducts
        "
        @item-click="trackingProductRecommendationClicked"
        :referer="PRODUCT_PAGE_MORE_ITEMS"
      />
    </template>
    <template
      v-else-if="loading || productStore.productRecommendationShopify?.length"
    >
      <h2 class="text--center">More Items To Consider</h2>
      <ProductListSlider
        :products="
          productStore.productRecommendationShopify?.length
            ? productStore.productRecommendationShopify
            : placeholderProducts
        "
        @item-click="trackingProductRecommendationClicked"
        :referer="PRODUCT_PAGE_MORE_ITEMS"
      />
    </template>
    <div class="product-recommend-button-group text--center">
      <sib-link
        v-if="productSeeMoreCollections?.nicheCollection"
        :to="
          buildCollectionUrl(productSeeMoreCollections.nicheCollection.handle)
        "
        :key="productSeeMoreCollections.nicheCollection.id"
        :title="productSeeMoreCollections.nicheCollection.title || ''"
        class="sib-button sib-button--primary"
        :class="{
          'sib-button--width-auto': !deviceStore.isMobile,
        }"
        @click="trackingClickButtonNicheCollection"
        :referer="PRODUCT_PAGE_EXPLORE_BUTTON"
      >
        Explore {{ productSeeMoreCollections.nicheCollection.title }} collection
      </sib-link>

      <sib-link
        v-if="productSeeMoreCollections?.typeCollection"
        :to="
          buildCollectionUrl(productSeeMoreCollections.typeCollection.handle)
        "
        :key="productSeeMoreCollections.typeCollection.id"
        :title="productSeeMoreCollections.typeCollection.title || ''"
        class="sib-button"
        :class="{
          'sib-button--width-auto': !deviceStore.isMobile,
        }"
        @click="trackingClickButtonTypeCollection"
        :referer="PRODUCT_PAGE_SEE_MORE_BUTTON"
      >
        See more {{ productSeeMoreCollections.typeCollection.title }}
      </sib-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, watch } from 'vue'
import ProductListSlider from '@/components/product/ProductListSlider.vue'
import { useProductRecentlyViewedItems } from '@/pages/product/composables/ProductRecentlyViewed'
import useProductStore from '@/store/product'
import { buildCollectionUrl, isProductHasTags } from '@/utils/product'
import useDeviceStore from '@/store/device'
import { Collection, Recommendation } from '@/types'
import {
  EVENT_TRACKING_SHOW_PRODUCT_RECOMMENDATION,
  TIME_MARK_CSR_LOAD_PAGE,
  TIME_MARK_SHOW_PRODUCT_RECOMMENDATION,
  CSR_LOAD_TYPE,
  MEASURE_NAME_PRODUCT_RECOMMENDATION_LOADED,
  EVENT_TRACKING_PRODUCT_RECOMMENDATION_CLICKED,
  EVENT_TRACKING_CLICK_BUTTON_NICHE_COLLECTION,
  EVENT_TRACKING_CLICK_TYPE_COLLECTION,
  MIXPANEL_DESTINATION,
  destinationIntegrations,
  PRODUCT_PAGE_MORE_ITEMS,
  PRODUCT_PAGE_EXPLORE_BUTTON,
  PRODUCT_PAGE_SEE_MORE_BUTTON,
  PRODUCT_PAGE_NICHE_ITEMS,
  QUERY_STRING_NO_CACHE,
  AB_TEST_RECOMMENDATION,
  AB_TEST_VARIANT_PRODUCT_MASS,
} from '@/utils'
import Analytics from '@/services/analytics'
import useRouteStore from '@/store/route'
import LocationService, { UserLocation } from '@/services/location'
import useUserStore from '@/store/user'
import { useRoute } from 'vue-router'
import { useABTest } from '@/composables/useABTest'

performance.mark(TIME_MARK_SHOW_PRODUCT_RECOMMENDATION)

const route = useRoute()
const routeStore = useRouteStore()
const productStore = useProductStore()
const deviceStore = useDeviceStore()
const userStore = useUserStore()
const { getRecentlyViewedItems } = useProductRecentlyViewedItems()
const { getABTestActivedVariantByCode } = useABTest()
const placeholderProducts = Array(10).fill(undefined)
let loading = ref(false)

const props = withDefaults(
  defineProps<{
    productSeeMoreCollections: {
      nicheCollection?: Collection
      typeCollection?: Collection
      similarNicheCollection?: Collection
    }
  }>(),
  {
    productSeeMoreCollections: () => ({}),
  }
)

const variantMassProductABTest = computed(() => {
  if (!productStore.isMotherOrGrandmaProduct) return false
  const abtestVariant = getABTestActivedVariantByCode(AB_TEST_RECOMMENDATION)
  if (abtestVariant === null) return false
  return abtestVariant == AB_TEST_VARIANT_PRODUCT_MASS
})

const hasNicheWeedProductTag = computed(() => {
  return isProductHasTags(productStore.product, ['niche-weed'])
})

onMounted(async () => {
  watch(
    () => productStore.product?.id,
    async (newVal, oldVal) => {
      if (newVal !== oldVal && newVal) {
        loading.value = true
        LocationService.onLocationReady(
          async (location: UserLocation | null) => {
            const countryCode = location?.country_code
            const recentlyViewedProducts = await getRecentlyViewedItems()
            if (!productStore.product) return
            const recomendationPayload: Recommendation = {
              recently_view: recentlyViewedProducts.map(
                (product) => product.handle
              ),
              product: {
                title: productStore.product.title,
                handle: productStore.product.handle,
                tags: productStore.product.tags || [],
                type: productStore.product.productType || '',
              },
              location: countryCode,
              user_segments: userStore.segments
                ? userStore.segments.map((segment) => segment.key)
                : [],
            }
            await productStore.getProductRecommendation(recomendationPayload)

            if (!productStore.productRecommendation?.moreItems?.length) {
              const isForceLoadNewData = !!route.query[QUERY_STRING_NO_CACHE]
              await productStore.getProductRecommendationsShopify({
                id: productStore.product.id,
                isForceLoadNewData,
              })
            }

            loading.value = false
          }
        )
      }
    },
    {
      immediate: true,
    }
  )
})

function trackingShowProductRecommendation() {
  if (!productStore.product?.handle) return
  const performanceTimeProdudctRecommendationLoaded =
    routeStore.loadType == CSR_LOAD_TYPE
      ? performance.measure(
          MEASURE_NAME_PRODUCT_RECOMMENDATION_LOADED,
          TIME_MARK_CSR_LOAD_PAGE
        ).duration
      : performance.now()
  const selfTimeProdudctRecommendationLoaded = performance.measure(
    MEASURE_NAME_PRODUCT_RECOMMENDATION_LOADED,
    TIME_MARK_SHOW_PRODUCT_RECOMMENDATION
  ).duration

  Analytics.track(
    EVENT_TRACKING_SHOW_PRODUCT_RECOMMENDATION,
    {
      performance_time: performanceTimeProdudctRecommendationLoaded,
      self_time: selfTimeProdudctRecommendationLoaded,
      handle: productStore.product.handle,
      load_type: routeStore.loadType,
    },
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

function trackingProductRecommendationClicked() {
  const abtestVariant = getABTestActivedVariantByCode(AB_TEST_RECOMMENDATION)
  if (abtestVariant === null || !productStore.isMotherOrGrandmaProduct) return

  const PRODUCT_COMPONENT = 'product_details'
  Analytics.track(
    EVENT_TRACKING_PRODUCT_RECOMMENDATION_CLICKED,
    {
      component: PRODUCT_COMPONENT,
      abTestVariant: abtestVariant,
    },
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

function trackingClickButtonNicheCollection() {
  if (
    productStore.product &&
    props.productSeeMoreCollections?.nicheCollection
  ) {
    // Analytics.track(
    //   EVENT_TRACKING_CLICK_BUTTON_NICHE_COLLECTION,
    //   {
    //     handle: productStore.product.handle,
    //     tags: productStore.product.tags,
    //     path: route.path,
    //     collection_handle: buildCollectionUrl(
    //       props.productSeeMoreCollections.nicheCollection.handle
    //     ),
    //   },
    //   destinationIntegrations([MIXPANEL_DESTINATION])
    // )
  }
}

function trackingClickButtonTypeCollection() {
  if (productStore.product && props.productSeeMoreCollections?.typeCollection) {
    // Analytics.track(
    //   EVENT_TRACKING_CLICK_TYPE_COLLECTION,
    //   {
    //     handle: productStore.product.handle,
    //     tags: productStore.product.tags,
    //     path: route.path,
    //     collection_handle: buildCollectionUrl(
    //       props.productSeeMoreCollections.typeCollection.handle
    //     ),
    //   },
    //   destinationIntegrations([MIXPANEL_DESTINATION])
    // )
  }
}
</script>

<style lang="scss">
.product-recommendation {
  @include media-md-down {
    h2 {
      font-size: 22px;
    }
    .divider {
      margin-bottom: 0;
    }
  }
}
.product-recommend-button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1em;
  margin-top: 2em;
  justify-content: center;
  @include media-md-up {
    margin-top: 3em;
    padding-top: 1em;
  }
}
.product-mass {
  .product-block {
    .image-rectangular {
      aspect-ratio: 1;
    }
    .mkc-detail {
      height: 0;
    }
  }
}
</style>
